import ProductCardDetail from "../../Product/Components/ProductCardDetail";
import VideoCardDetail from "../../Video/Components/VideoCardDetail";

export const DetailsSection = ({ cardType, item, videoProducts, note }) => {
  const renderDetails = () => {
    switch (cardType) {
      case "Product":
        return <ProductCardDetail item={item} />;
      case "Video":
        return (
          <VideoCardDetail
            item={item}
            videoProducts={videoProducts}
            note={note}
          />
        );
      default:
        return null;
    }
  };

  return renderDetails();
};
